import { useQuery } from "@tanstack/react-query"

import type { ChatSessionQueryScope } from "@/features/chat/hooks/chat-request-registry"

import { getAgentStateApi } from "@/api/api"
import { queryKeys } from "@/lib/query-keys"
import { SettingsService } from "@/services/settings-service"
import { KNOWN_SESSION_TYPES } from "@/types"

/**
 * Hook to fetch agent state for an Explorer session.
 *
 * `scope` works as in useSessionMessages (#3524).
 */
export function useAgentState(
  sessionId: string | undefined,
  sessionType: string,
  scope?: ChatSessionQueryScope
) {
  const settingsService = SettingsService.getInstance()

  return useQuery({
    queryKey: queryKeys.agentStateQuery(sessionId || "", scope?.incarnation),
    queryFn: () => getAgentStateApi(sessionId!, settingsService.token),
    // Only for Explorer sessions, and never while the chat is deleted
    enabled: !!sessionId && sessionType === KNOWN_SESSION_TYPES.Explorer && !scope?.disposed,
    staleTime: 1000 * 30, // 30 seconds - agent state can change frequently
    gcTime: 1000 * 60 * 2, // Keep in cache for 2 minutes
    refetchOnWindowFocus: false,
  })
}
